import styled from 'styled-components';

export const Bar = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
`;

export const Steps = styled.div`
  display: flex;
  gap: 6px;
  position: relative;
`;

export const ItemsMenu = styled.div`
  position: absolute;
  top: 34px;
  left: 70px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
  padding: 4px;
  width: 280px;
  z-index: 110;
`;

export const ItemsMenuEntry = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #f1f5f9;
  }
`;

export const ItemsMenuStatus = styled.span<{ locked?: boolean }>`
  font-size: 12px;
  color: ${({ locked }) => (locked ? '#b45309' : '#059669')};
  white-space: nowrap;
`;

export const StepButton = styled.button<{ active?: boolean }>`
  border: none;
  background: ${({ active }) => (active ? '#0090D3' : 'transparent')};
  color: ${({ active }) => (active ? '#ffffff' : '#64748b')};
  font-size: 13px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: ${({ active }) => (active ? '#0090D3' : '#f1f5f9')};
  }
`;
